import React, { FunctionComponent, useState } from 'react';
import withStyles from 'react-jss';
import { Container } from 'semantic-ui-react';
import { isAfter, parseISO } from 'date-fns';

import Button from 'components/Button';
import OfferDetailsPlaceholder from 'components/Placeholder/presets/OfferDetailsPlaceholder';
import { ClassProp } from 'helpers/types';

import DisplayTimeStamp from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/components/DisplayTimestamp';
import SetOfferProperties from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/components/SetOfferProperties/SetOfferProperties';
import SetOfferLimits from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/components/SetOfferLimits/SetOfferLimits';
import { OfferSummary } from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/MerchantOffer.types';

import styles from './OfferDetails.styles';
import ToggleVenuesModal from './ToggleVenuesModal';

type Styles = ClassProp<ReturnType<typeof styles>>;

type Props = {
  classes: Styles;
  offer?: OfferSummary;
};

const OfferDetails: FunctionComponent<Props> = ({ classes, offer }) => {
  const [updateOffer, setUpdateOffer] = useState<boolean>(false);
  const [updateOfferLimit, setUpdateOfferLimit] = useState<boolean>(false);

  const handleUpdateOfferClick = () => {
    setUpdateOffer(true);
  };

  const handleUpdateOfferLimitClick = () => {
    setUpdateOfferLimit(true);
  };

  if (offer === undefined) {
    return <OfferDetailsPlaceholder />;
  }

  const offerHasStarted = isAfter(new Date(), parseISO(offer.offerStartDate));
  return (
    <Container className={classes.container}>
      {updateOfferLimit ? (
        <SetOfferLimits offer={offer} cancelUpdate={setUpdateOfferLimit} />
      ) : updateOffer ? (
        <SetOfferProperties offer={offer} cancelUpdate={setUpdateOffer} />
      ) : (
        <>
          <h3 className={classes.header}>Offer Details</h3>
          {offer.offerDescription && (
            <>
              <span className={classes.textLabel}>Offer Description</span>
              <p>{offer.offerDescription}</p>
            </>
          )}
          {offer.offerKeywords && (
            <>
              <span className={classes.textLabel}>Offer Keywords:</span>
              <p>{offer.offerKeywords}</p>
            </>
          )}
          {offer.paymentNetworkMCCDescription && (
            <>
              <span className={classes.textLabel}>
                Merchant Category Codes:
              </span>
              <p>{offer.paymentNetworkMCCDescription}</p>
            </>
          )}
          <p>
            <DisplayTimeStamp
              label="Offer Start:"
              date={offer.offerStartDate}
            />
            <DisplayTimeStamp label="Offer End:" date={offer.offerEndDate} />
          </p>
          <Button
            className={classes.smallBtn}
            title="Update Offer"
            onClick={handleUpdateOfferClick}
          />
          <Button
            className={classes.smallBtn}
            title="Update Offer Limits"
            onClick={handleUpdateOfferLimitClick}
            disabled={offerHasStarted}
          />
          <ToggleVenuesModal />
        </>
      )}
    </Container>
  );
};

export default withStyles(styles)(OfferDetails);
